import { CurrentSubscriptionStatus } from "@gymflow/types";
import { useTranslation } from "react-i18next";

import { DotBadge, DotBadgeProps } from "../../../../../atoms/DotBadge";

type HostedPagesProfileStatusProps = {
  status: CurrentSubscriptionStatus;
};

const STATUS_MAP: Record<CurrentSubscriptionStatus, DotBadgeProps["intent"]> = {
  ACTIVE: "success",
  PENDING: "lightblue",
  ACTIVE_CHANGING: "success",
  ACTIVE_PAUSING: "success",
  ACTIVE_CANCELLING: "success",
  PAUSED: "warning",
  OVERDUE_AUTH_NEEDED: "error",
  OVERDUE_PAYMENT: "error",
};

export const HostedPagesProfileStatus = ({
  status,
}: HostedPagesProfileStatusProps) => {
  const { t } = useTranslation();
  const intent = STATUS_MAP[status];

  return (
    <DotBadge intent={intent}>
      {t(`portal.common.subscriptionStatus.${status}`)}
    </DotBadge>
  );
};
